import React from 'react';
import classNames from 'classnames';

import { FONT_SIZES } from '../../../constants/font.constants';

export const SubHeadingLabel = ({
  bold = false, 
  className, 
  children, 
  size = FONT_SIZES.XL,
  ...rest
}) => (
  <h2 
    className={classNames(`text-white text-${size}`, className, {
      'font-bold': bold,
    })}
    {...rest}
  >
    { children }
  </h2>
)

export default SubHeadingLabel;
